import { Routes } from '@angular/router';
import { EngagementsComponent } from './engagements.component';
import { FormulairePiComponent } from './pages/formulaires/formulaire-pi/formulaire-pi.component';
import { FormulaireGpComponent } from './pages/formulaires/formulaire-gp/formulaire-gp.component';
import { VERGERS_ECORESPONSABLES_ROUTES } from './pages/vergers-ecoresponsables/vergers-ecoresponsables.routes';

export const ENGAGEMENTS_ROUTES: Routes = [
    {
        path: '',
        component: EngagementsComponent,
        data: {
            domaines: ['ANPP'],
            role: 'HABILITATION_ENGAGEMENT_VER_LECTURE',
            menu: {
                icon: 'medal',
                libelle: 'menu.engagements'
            }
        },
        children: [
            { path: '', redirectTo: 'vergers-ecoresponsables', pathMatch: 'full' },
            {
                path: 'vergers-ecoresponsables',
                children: VERGERS_ECORESPONSABLES_ROUTES
            },
            { path: 'formulaire-pi', component: FormulairePiComponent },
            {
                path: 'formulaire-pi/:id',
                component: FormulairePiComponent,
                data: { roles: ['ORGANISME'] }
            },
            { path: 'formulaire-gp', component: FormulaireGpComponent },
            {
                path: 'formulaire-gp/:id',
                component: FormulaireGpComponent,
                data: { roles: ['ORGANISME'] }
            }
        ]
    }
];
